import React from "react";
import {connect} from "react-redux";

import Attributes from "./Attributes";
import Context from "../../../context/Context";
import InfoPanelHeader from "./InfoPanelHeader";
import Rdx from "../../../redux/Rdx";
import Related from "./Related";
import RealTimeLocation from "./RealTimeLocation";
import ShareDropdown from "./ShareDropdown";
import Topic from "../../../context/Topic";
import * as Actions from "./Actions";
import * as actionUtil from "./actionUtil";
import * as appLaunchUtil from "../../../aiim/util/appLaunchUtil";
import * as component from "../../util/component";
import * as itemUtil from "../../../aiim/util/itemUtil";
import * as shareUtil from "./shareUtil";

const CSS = {
  main: "i-content",
  infopanelContent: "i-infopanel-content",
  featureContent: "i-infopanel-content-feature",
  actionBar: "i-actionbar",
  tabs: "tab-nav",
  tab: "tab-title",
  activeTab: "is-active",
  tabContent: "i-infopanel-feature-tabcontent"
};

class ItemDetails extends React.Component {

  constructor(props) {
    super(props);
    const item = this.props.item;
    this.state = component.newState({
      activeTab: "attributes",
      appLaunchUrls: [],
      mode: "details",
      _311Url: null,
      shareUrl: shareUtil.generateShareUrl(item)
    });
    this.modeClicked = this.modeClicked.bind(this);
    this.tabClicked = this.tabClicked.bind(this);
  }

  componentDidMount() {
    //this.generate311Url();
    this.generateAppLaunchUrls()
    component.own(this,[
      Topic.subscribe(Topic.AppLaunchURLsChanged,params => {
        this.generateAppLaunchUrls();
      }),
      Topic.subscribe(Topic.ReferenceLayerUpdated,params => {
        component.refresh(this);
      }),
      Topic.subscribe(Topic.Three11UrlChanged,params => {
        this.generate311Url();
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  generateAppLaunchUrls() {
    appLaunchUtil.generateUrls(this.props.item).then(urls => {
      //console.log("urls222",urls);
      this.setState(state => {
        return {
          appLaunchUrls: urls
        };
      });
    }).catch(ex => {
       console.error("Error generating app launch urls",ex);
    });
  }

  generate311Url() {
    actionUtil.generate311Url(this.props.item).then(url => {
      this.setState(state => {
        return {
          _311Url: url
        };
      });
    }).catch(ex => {
       console.error("Error generating 311 URL",ex);
    });
  }

  getCaption() {
    const v = this.props.item.getTitle();
    if (typeof v === "string") return v;
    return "";
  }

  getFeature() {
    return (this.props.item.getFeature());
  }

  getSource() {
    return (this.props.item.getSource());
  }

  modeClicked(mode) {
    // const activeModeKey = this.props.infoPanelKey + "-ItemDetails-ActiveMode";
    // if (mode) {
    //   Rdx.setValue(this,activeModeKey,mode);
    // }
    this.setState(state => {
      return {
        mode: mode
      };
    });
    if (this.props.realTimeToggled) this.props.realTimeToggled(mode);
  }

  render() {
    return (
      <div className={CSS.main}>
        {this.renderHeader()}
        {this.renderContent()}
      </div>
    );
  }

  renderActions() {
    const isKiosk = Context.getInstance().isKiosk;
    const item = this.props.item;
    const appLaunchUrls = this.state.appLaunchUrls;
    const listItems = [];

    const source = this.getSource();
    const feature = this.getFeature();
    const hasGeometry = itemUtil.hasGeometry(source,feature);

    if (item && item.isValid()) {
      if (Context.getInstance().config.networkServiceUrl) {
        listItems.push(
          <li key="directions"><Actions.Directions item={item} disabled={!hasGeometry}/></li>
        );
      }
      if (!isKiosk) {
        listItems.push(
          <li key="setHome"><Actions.SetHome item={item} disabled={!hasGeometry}/></li>
        );
        listItems.push(
          <li key="saveFavorite"><Actions.SaveFavorite item={item} disabled={!hasGeometry}/></li>
        );
        if (this.state.shareUrl) {
          listItems.push(
            <li key="share"><ShareDropdown shareUrl={this.state.shareUrl}/></li>
          );
        }

        // if (this.state._311Url) {
        //   listItems.push(
        //     <li key="launch311"><Actions.Launch311 _311Url={this.state._311Url}/></li>
        //   );
        // }

        if (appLaunchUrls && appLaunchUrls.length > 0) {
          listItems.push(
            <li key="appLaunch"><Actions.AppLaunch urls={appLaunchUrls}/></li>
          );
        }

      }
    }

    if (listItems.length === 0) return null;
    return (
      <ul className={CSS.actionBar}>
        {listItems}
      </ul>
    );
  }

  renderContent() {
    const i18n = Context.getInstance().i18n;
    //const isKiosk = Context.getInstance().uiMode.isKiosk;
    const isAnonymous = Context.getInstance().user.isAnonymous();
    const feature = this.getFeature();
    //if (!feature || !feature.geometry) {
    if (!feature) {
      return (
        <div className="i-padded">
          <p>{i18n.infoPanel.messages.noGeometry}</p>
        </div>
      );
    }
    const source = this.getSource();
    const item = this.props.item;
    const itemIsValid = (source && item && item.isValid());
    const hasGeometry = itemUtil.hasGeometry(source,feature);

    let canObserve = false, realTime = null;
    const detailsStyle = {};
    //const activeMode = this.props.rdxActiveMode || "details";
    const activeMode = this.state.mode || "details";
    //if (!isKiosk && !isAnonymous && itemIsValid && source.isAiimPeople()) {
    if (!isAnonymous && itemIsValid && source.isAiimPeople()) {
      const trackingViews =  Context.getInstance().user.trackingViews;
      if (trackingViews) {
        canObserve = trackingViews.canObserve(source,feature);
        if (canObserve) {
          if (activeMode === "realtime") detailsStyle.display = "none";
          realTime = (
            <RealTimeLocation infoPanelKey={this.props.infoPanelKey} item={item}
              modeClicked={this.modeClicked} />
          );
        }
      }
    }

    const activeTab = this.props.rdxActiveTab || "attributes";
    const tabs = (
      <>
      {/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */}
      <nav className={CSS.tabs} role="tablist">
        {this.renderTab(activeTab,"attributes",i18n.infoPanel.tabs.attributes)}
        {this.renderTab(activeTab,"related",i18n.infoPanel.tabs.related,!hasGeometry)}
      </nav>
      </>
    );
    let tabContent = null;
    if (itemIsValid) {
      tabContent = (
        <div key="i-feature-tabcontent" className={CSS.tabContent}>
          <Attributes item={item} active={activeTab === "attributes"}/>
          <Related item={item} active={activeTab === "related"}/>
        </div>
      );
    }

    return (
      <div key="i-infopanel-content" className={CSS.infopanelContent}>
        {realTime}
        <div key="i-feature-content" className={CSS.featureContent} style={detailsStyle}>
          {this.renderActions()}
          {tabs}
          {tabContent}
        </div>
      </div>
    );
  }

  renderHeader() {
    const caption = this.getCaption();
    return <InfoPanelHeader caption={caption} infoPanelKey={this.props.infoPanelKey}/>;
  }

  renderTab(activeTab,type,label,disabled) {
    const hashref = "#";
    let className = CSS.tab;
    const selected = (activeTab === type);
    if (selected) className += " " + CSS.activeTab;
    if (disabled) className += " i--disabled";
    const tab = (
      <a className={className} href={hashref} role="tab" aria-selected={selected}
      onClick={this.tabClicked} data-tabtype={type}><span data-tabtype={type}>{label}</span></a>
    )
    return tab;
  }

  tabClicked(event) {
    try {
      const activeTabKey = this.props.infoPanelKey + "-ItemDetails-ActiveTab";
      const type = event.target.getAttribute("data-tabtype");
      if (type) {
        Rdx.setValue(this,activeTabKey,type);
      }
    } catch(ex) {
      console.warn("Error handling tab click for event:",event);
      console.error(ex);
    }
  }

}

const mapStateToProps = (state,ownProps) => {
  //const activeModeKey = ownProps.infoPanelKey + "-ItemDetails-ActiveMode";
  const activeTabKey = ownProps.infoPanelKey + "-ItemDetails-ActiveTab";
  return {
    //rdxActiveMode: Rdx.getValue(state,activeModeKey),
    rdxActiveTab: Rdx.getValue(state,activeTabKey)
  }
}

export default connect(mapStateToProps)(ItemDetails);
